import React from "react";
import { Navigate } from "react-router-dom";
import { useMembership } from "../context/MembershipContext";
import { firstAllowedPath, screenFor } from "../constants/navigation";
import { useI18n } from "../i18n";

/**
 * Shows a screen only to someone it has been given to, and sends anyone else
 * to the first screen they do have — so signing in as a cashier lands on
 * something useful rather than a page of refusals.
 */
const RequirePermission = ({ screen, children }) => {
  const { t } = useI18n();
  const { loading, isOffered } = useMembership();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-primary-600" />
      </div>
    );
  }

  if (isOffered(screenFor(screen))) return children;

  const fallback = firstAllowedPath(isOffered);

  if (fallback) return <Navigate to={fallback} replace />;

  return (
    <div className="bg-white rounded-xl shadow-lg p-8 text-center">
      <p className="text-4xl mb-3">🔒</p>
      <p className="font-semibold text-gray-800">{t("nav.noAccessTitle")}</p>
      <p className="text-sm text-gray-500 mt-1">{t("nav.noAccessHint")}</p>
    </div>
  );
};

export default RequirePermission;
